import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import api from "../lib/api";
import { useCart } from "../contexts/CartContext";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { Button } from "../components/ui/button";

export default function CheckoutSuccess() {
  const [params] = useSearchParams();
  const session_id = params.get("session_id");
  const [status, setStatus] = useState("polling"); // polling | paid | expired | error
  const [details, setDetails] = useState(null);
  const { clear } = useCart();

  useEffect(() => {
    if (!session_id) { setStatus("error"); return; }
    let attempts = 0;
    const max = 10;
    const poll = async () => {
      try {
        const r = await api.get(`/payments/status/${session_id}`);
        setDetails(r.data);
        if (r.data.payment_status === "paid") { setStatus("paid"); clear(); return; }
        if (r.data.status === "expired") { setStatus("expired"); return; }
        if (attempts++ < max) setTimeout(poll, 2000);
        else setStatus("error");
      } catch { if (attempts++ < max) setTimeout(poll, 2000); else setStatus("error"); }
    };
    poll();
    // eslint-disable-next-line
  }, [session_id]);

  return (
    <div data-testid="checkout-success-page" className="container-xl py-24 text-center max-w-xl">
      {status === "polling" && (
        <>
          <Loader2 className="h-16 w-16 mx-auto animate-spin text-[hsl(var(--primary))]" />
          <h1 className="editorial-heading text-4xl mt-6">Verifica pagamento…</h1>
          <p className="text-muted-foreground mt-2">Stiamo confermando la transazione con Stripe.</p>
        </>
      )}
      {status === "paid" && (
        <>
          <CheckCircle2 className="h-16 w-16 mx-auto text-[hsl(var(--secondary))]" />
          <h1 className="editorial-heading text-5xl mt-6">Grazie!</h1>
          <p className="text-muted-foreground mt-2">Il pagamento è stato ricevuto. Ti abbiamo inviato la conferma via email.</p>
          {details && <div className="text-sm text-muted-foreground mt-3">Totale: {(details.amount_total/100).toFixed(2)} {details.currency?.toUpperCase()}</div>}
          <div className="mt-6 flex gap-3 justify-center">
            <Link to="/area-utente"><Button className="bg-[hsl(var(--primary))] text-white hover:bg-[hsl(var(--primary))]/90 rounded-sm">I miei ordini</Button></Link>
            <Link to="/"><Button variant="outline" className="rounded-sm">Torna alla home</Button></Link>
          </div>
        </>
      )}
      {(status === "expired" || status === "error") && (
        <>
          <XCircle className="h-16 w-16 mx-auto text-destructive" />
          <h1 className="editorial-heading text-4xl mt-6">Pagamento non completato</h1>
          <p className="text-muted-foreground mt-2">La sessione è scaduta o è stata annullata. Riprova.</p>
          <Link to="/carrello"><Button className="mt-6 bg-[hsl(var(--primary))] text-white rounded-sm">Torna al carrello</Button></Link>
        </>
      )}
    </div>
  );
}
